<glxy-form-field prefixIcon="search" bottomSpacing="none" minWidth="240px">
  <input
    matInput
    type="search"
    [formControl]="searchCtrl"
    [value]="this.currentTerm$ | async"
    [placeholder]="i18nPlaceholderToken | translate"
  />
</glxy-form-field>
